import React,{lazy} from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { Providers } from './components';
const Providers = lazy(() => import(/* webpackChunkName: "Providers" */ './components'));

const routes = () => (
  <PrivateRoute exact path="/settings/providers" component={Providers} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/providers/routes.js